import { useNavigate } from 'react-router-dom';

export const useNavigateToRoute = (route: string = '../'): (() => void) => {
  const navigate = useNavigate();
  return () => {
    navigate(route);
  };
};
